import { render, staticRenderFns } from "./lesson-video-gallery.vue?vue&type=template&id=a53e9ae2&scoped=true"
import script from "./lesson-video-gallery.vue?vue&type=script&lang=js"
export * from "./lesson-video-gallery.vue?vue&type=script&lang=js"
import style0 from "./lesson-video-gallery.vue?vue&type=style&index=0&id=a53e9ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53e9ae2",
  null
  
)

export default component.exports